// Modal shown when a user tries to add a source past the per-collection
// domain cap. Cap mirrors the BE Pydantic validators — see
// `src/components/library/constants.ts`.

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@heidi/design-system/alert-dialog';
import { FormattedMessage, useIntl } from 'react-intl';

interface CollectionCapDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  maxDomains: number;
}

export const CollectionCapDialog = ({
  open,
  onOpenChange,
  maxDomains,
}: CollectionCapDialogProps) => {
  const intl = useIntl();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="collection-cap-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>
            <FormattedMessage
              defaultMessage="Source limit reached"
              id="4+UdcyRghU"
              description="Title of the dialog shown when a user tries to add a source past the per-collection domain cap"
            />
          </AlertDialogTitle>
          <AlertDialogDescription>
            <FormattedMessage
              defaultMessage="Collections can include at most {max, number} sources. Remove a source from this collection before adding another."
              id="b2Y4FMyaeV"
              description="Body of the dialog shown when a user tries to add a source past the per-collection domain cap"
              values={{ max: maxDomains }}
            />
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={() => onOpenChange(false)}
            aria-label={intl.formatMessage({
              defaultMessage: 'Dismiss source-limit dialog',
              id: 'p8mKb34469',
              description:
                'Accessibility label for the dismiss button on the per-collection source-cap dialog',
            })}
          >
            <FormattedMessage
              defaultMessage="Got it"
              id="IEgMHnDn3D"
              description="Dismiss button label on the per-collection source-cap dialog"
            />
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
